import React from 'react'

import Container from '../../../components/structure/Container'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Footer from './Footer'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'
import ExecutionDynamicServiceOrder from './ExecutionDynamicServiceOrder'
import { useDynamicServiceOrders } from './_load/DynamicServiceOrdersLoader'
import FullPageMessage from '../../../components/presentation/FullPageMessage'
import ImperativeComponents from '../../../containers/dynamic/form/replies/context/ImperativeComponentsContext'

const ExecutionPageContent = () => {
  const { id } = useDynamicServiceOrders()

  if (!id)
    return (
      <FullPageMessage
        title="Essa atividade não existe"
        description="Verifique se o link está correto. Qualquer coisa entre em contato com o suporte."
        icon="BsFillXCircleFill"
        iconColor="red"
      />
    )

  return (
    <ImperativeComponents>
      <PageHeader />
      <Separator weight={4} />
      <FlexGrid align="stretch">
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={4}>
          <Container maxWidth="44rem">
            <ExecutionDynamicServiceOrder />
            <Footer />
          </Container>
        </FlexCol>
        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
      </FlexGrid>
      <Separator weight={32} />
    </ImperativeComponents>
  )
}

export default ExecutionPageContent
